import { useEffect, useRef } from 'react';

export function useAutosave(key, data) {
  const isFirst = useRef(true);
  useEffect(() => {
    if (isFirst.current) { isFirst.current = false; return; }
    const timer = setTimeout(() => {
      localStorage.setItem(key, JSON.stringify(data));
    }, 500);
    return () => clearTimeout(timer);
  }, [key, data]);
}

export function loadDraft(key) {
  try { return JSON.parse(localStorage.getItem(key)); } catch { return null; }
}

export function clearDraft(key) {
  localStorage.removeItem(key);
}
